<script setup lang="ts">
import { GetEntitiesFromVersion } from '@/lib/entityInfo';
import { CreateEntityData } from '@/lib/trashsim/entities';
import type { Fleet } from '@/lib/trashsim/fleet';
import Format from '@/lib/trashsim/format';
import { shipNoNulls } from '@/lib/trashsim/loaders/fleet';
import type { Settings } from '@/lib/trashsim/settings';
import type { Resources } from '@/lib/trashsim/types';
import ResourceOutput from '@/components/common/ResourceOutput.vue';

const props = defineProps<{
    plunder?: Resources | null
    resources: Resources
    settings: Settings
    attacker: Fleet
}>()

const getEntitiesForPlunder = (entity: string): number => {
    let sum = Math.ceil(
        (props.resources.food || 0) +
        (props.resources.metal || 0) +
        (props.resources.crystal || 0) +
        (props.resources.deuterium || 0)
    )

    // let cap = flight.Capacity(entity)
    const entities = GetEntitiesFromVersion(props.settings.version)
    let cap = CreateEntityData(entity, shipNoNulls(props.attacker.ships[entity]), entities[entity], props.attacker, props.settings).cargo || 0

    return Math.ceil((sum * (props.settings.plunder/100)) / cap)
} 
// <ResourceOutput :value="sum(total?.plunder)" resource="total" label="=" />
</script>

<template>
    <div class="result-table result-table-plunder">
        <table class="resource-table">
            <thead>
                <tr>
                    <th colspan="6">{{ $t('home.result.plunder.title') }}</th>
                </tr>
                <tr>
                    <th colspan="2">{{ $t('home.result.plunder.captured') }}</th>
                    <th colspan="2">{{ $t('home.result.plunder.possible') }}</th>
                    <th colspan="2">{{ $t('home.result.plunder.cargos') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <ResourceOutput :value="plunder?.metal" resource="metal" />
                    <ResourceOutput :value="(resources.metal || 0)*settings.plunder/100" resource="metal" />
                    <td>{{ Format.Number(getEntitiesForPlunder("203")) }}</td>
                    <td>{{ $t('type.203') }}</td>
                </tr>
                <tr>
                    <ResourceOutput :value="plunder?.crystal" resource="crystal" />
                    <ResourceOutput :value="(resources.crystal || 0)*settings.plunder/100" resource="crystal" />
                    <td>{{ Format.Number(getEntitiesForPlunder("202")) }}</td>
                    <td>{{ $t('type.202') }}</td>
                </tr>
                <tr>
                    <ResourceOutput :value="plunder?.deuterium" resource="deuterium" />
                    <ResourceOutput :value="(resources.deuterium || 0)*settings.plunder/100" resource="deuterium" />
                    <td>{{ Format.Number(getEntitiesForPlunder("219")) }}</td>
                    <td>{{ $t('type.219') }}</td>
                </tr>
                <tr>
                    <ResourceOutput :value="plunder?.food" resource="food" />
                    <ResourceOutput :value="(resources.food || 0)*settings.plunder/100" resource="food" />
                    <!-- <td>{{ Format.Number(getEntitiesForPlunder("219")) }}</td>
                    <td>{{ $t('type.219') }}</td> -->
                </tr>
            </tbody>
        </table>
    </div>
</template>